<template>
    <g>
        <g>
            <path :style="{ fill: color }" d="M31.4,79.4c2.5-0.8,4.5-1.5,5.5-1.8c0.4-0.2,0.7-0.2,0.7-0.2l3.3-1.1c0.8-0.3,1.3-1,1.3-1.9l-0.1-6
			c-2.5-2.7-4.6-5.7-5.8-8.2c-0.8-1.7-1.5-4-2-6.8c-0.3,0.2-0.6,0.5-0.9,0.5c-0.5,0-0.9,0-1.3-0.3c0,8.5-0.2,20.3-2.4,26
			c0,0-0.3,0.4-0.3,0.5C30.1,79.8,30.8,79.6,31.4,79.4z"/>
            <path :style="{ fill: color }" d="M65.9,74.3c0,0.9,0.5,1.6,1.3,1.9l3.3,1.1c0,0,0.3,0.1,0.7,0.2c1,0.3,3,1,5.5,1.8
			c0.8,0.2,1.6,0.5,2.4,0.8c-3-5.7-3.5-18.8-3.6-26.9c-0.3,0.2-0.7,0.3-1.1,0.3c-0.4,0-0.7-0.1-1-0.4c-0.3,2.1-0.7,3.8-1.1,5.1
			c-0.2,0.7-0.5,1.5-0.9,2.3c0,0,0,0,0,0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5
			c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.2
			c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4
			c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.2,0.3
			c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0.1
			L65.9,74.3z"/>
        </g>
        <path :style="{ fill: color }" d="M79.5,29.9c-1.9-3-3.6-4.5-4.6-6.7S69.9,9.7,63.4,8.9c-6.5-0.9-9.6,2.3-9.6,2.3S50.6,8,44.2,8.9
		C37.7,9.7,33.6,21,32.6,23.2c-1,2.2-2.7,3.7-4.6,6.7c-1.9,3-2.7,9.4-1.2,12.8c0.3,0.6,0.7,1.1,1.3,1.5c0-0.4,0-0.8,0.2-1.2
		c1-2.9,3.5-2.3,5.1-1.3c0,0,0,0,0,0l0,0c0.2,0.2,0.5,0.3,0.7,0.5l0.6,3.1l1.1,3.2l0.3-8.5c1.2-0.1,4-0.6,7.1-3.7
		c4.1-4.2,3.8-10.5,5.8-11.7c2-1.2,3.7,0.5,4.9,0.5c1.2,0,2.8-1.8,4.9-0.5c2,1.2,1.7,7.5,5.8,11.7c3.1,3.1,5.9,3.7,7.1,3.7l0.3,8.5
		l1.2-3.3l0.6-3.1c0.2-0.2,0.4-0.3,0.6-0.5l0,0c0,0,0,0,0.1,0c1.6-1,4-1.6,5.1,1.3c0.1,0.3,0.2,0.7,0.2,1.2c0.6-0.4,1-0.9,1.3-1.5
		C82.3,39.4,81.4,32.9,79.5,29.9z"/>
    </g>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair11',
        mixins: [Hair],
    }
</script>

